import { injectIntl } from 'react-intl';
import { Modal } from 'antd';
import classnames from 'classnames';

import BRButton from 'components/BRButton/BRButton';

import { ReactComponent as CloseIcon } from 'assets/bosta-icons/Close.svg';

import './BRModal.less';

const BRModal = ({ intl, close, ...props }) => {
  const {
    title,
    type,
    width,
    closeIcon,
    coverImage,
    contentTitle,
    modalClassName,
    contentBody,
    primaryLabel,
    secondaryLabel,
    primaryAction = () => {},
    secondaryAction = () => {}
  } = props;

  const handlePrimaryAction = () => {
    primaryAction();
    close();
  };

  const handleSecondaryAction = () => {
    secondaryAction();
    close();
  };

  const handleClose = () => {
    close();
  };

  return (
    <Modal
      onCancel={handleClose}
      width={width}
      title={title && <div className="br-modal-title ">{title}</div>}
      wrapClassName={classnames('br-modal', modalClassName, type)}
      footer={
        <div className={`${modalClassName}__footer br-modal__footer`}>
          <BRButton
            className="button"
            type={'primary'}
            label={primaryLabel}
            onClick={handlePrimaryAction}
          />
          {secondaryLabel && (
            <BRButton
              className="button"
              type={'basic'}
              label={secondaryLabel}
              onClick={handleSecondaryAction}
            />
          )}
        </div>
      }
      maskClosable={false}
      {...props}
    >
      <div className={`${modalClassName}__content br-modal__content`}>
        {closeIcon && (
          <CloseIcon
            className="br-modal__content__close"
            onClick={handleClose}
          />
        )}
        {coverImage && <img alt="modal-cover" src={coverImage} />}
        {contentTitle && contentTitle}
        <span className="br-modal__content__body">{contentBody}</span>
      </div>
    </Modal>
  );
};

export default injectIntl(BRModal);
